import type { Price as PaymentServicePrice } from '@/clients/payment-service'

export type StripePriceForTracking = Pick<PaymentServicePrice, 'lookup_key' | 'nickname' | 'recurring'>

export type StripeTrackingData = {
  [lookupKey: string]: {
    nickname: string
    period: string
  }
}

export const priceRecurringIntervalToPeriod = (
  recurring:
    | {
        interval: string
        interval_count: number
      }
    | null
    | undefined,
) => {
  return recurring
    ? recurring.interval_count + ' ' + recurring.interval.toLowerCase() + (recurring.interval_count > 1 ? 's' : '')
    : 'One off payment'
}

export const getPricesTrackingData = (stripePrices: StripePriceForTracking[]): StripeTrackingData => {
  return stripePrices.reduce((formattedPrices, price) => {
    if (!price.lookup_key || !price.nickname) {
      return formattedPrices
    }

    const productSubscriptionPeriod = priceRecurringIntervalToPeriod(price.recurring)

    return {
      ...formattedPrices,
      [price.lookup_key]: {
        nickname: price.nickname,
        period: productSubscriptionPeriod,
      },
    }
  }, {})
}
